<template>
  <div class="modal fade" id="manageStudentManagersModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Manage {{ student.Name }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-left">
          <form @submit.prevent="updateManagers" key="name">
            <label>Student Managers</label>
            <div
              v-for="user in Users.slice().sort($orderByLastName)"
              :key="user.User_Id + 'user'"
              class="form-group form-check"
            >
              <input
                type="checkbox"
                class="form-check-input"
                v-bind:id="'user' + user.User_Id"
                v-bind:value="user.User_Id"
                v-model="newStudentManagers"
              />
              <label class="form-check-label" v-bind:for="'user' + user.User_Id"
                >{{ user.First_Name }} {{ user.Last_Name }}
              </label>
            </div>
            <div class="row">
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-primary"
                  v-on:click="cancel"
                >
                  Cancel
                </button>
              </div>
              <div class="col" />
              <div class="col-auto">
                <button type="submit" class="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    Users: Array,
    Student: Object
  },
  data() {
    return {
      student: this.Student,
      newStudentManagers: [],
      currStudentManagers: []
    };
  },
  watch: {
    Student: function() {
      this.assignStudent();
    }
  },
  mounted() {
    this.assignStudent();
  },
  methods: {
    assignStudent() {
      this.student = this.Student;
      this.newStudentManagers = this.originalUsers();
      this.currStudentManagers = this.originalUsers();
    },

    originalUsers() {
      return this.Users.filter(u =>
        u.Permissions.some(p => p.Student_Id == this.student.Student_Id)
      ).map(u => u.User_Id);
    },

    async updateManagers() {
      $("#manageStudentManagersModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      await view
        .updateStudentManagers(this.student.Student_Id)
        .then(async () => {
          view.currStudentManagers = view.newStudentManagers;
          view.$store.commit("updateLoading", false);
          view.$emit("student-managers-updated");
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#manageStudentManagersModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async updateStudentManagers(studentId) {
      var view = this;
      var usersToAdd = this.newStudentManagers.filter(
        u => !this.currStudentManagers.includes(u)
      );
      if (usersToAdd.length > 0) {
        await view.$createUserPermissionsForStudent(usersToAdd, studentId, 8);
      }
      var usersToRemove = this.currStudentManagers.filter(
        u => !this.newStudentManagers.includes(u)
      );
      if (usersToRemove.length > 0) {
        var userPermissionIds = [];
        usersToRemove.forEach(userId => {
          var user = this.Users.find(u => u.User_Id == userId);
          userPermissionIds.push(
            user.Permissions.find(p => p.Student_Id == studentId)
              .User_Permission_Id
          );
        });
        await view.$removeUserPermissions(userPermissionIds);
      }
    },
    clearFields() {
      this.newStudentManagers = this.currStudentManagers;
    },
    cancel() {
      $("#manageStudentManagersModal").modal("hide");
    }
  }
};
</script>
